<script>
import { mapState } from "vuex";

export default {
	name: "compKomuniDetail",
	data() {
		return {};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKomuniItem: (state) => state.umatKomuni.item,
		}),
	},
};
</script>

<template>
<table class="table table-striped table-hover text-left">
					<tbody>
						<tr>
							<td>No Buku LSC</td>
							<td>:</td>
							<td>{{ umatKomuniItem.no_buku_lsc }}</td>
						</tr>
						<tr>
							<td>No LSC</td>
							<td>:</td>
							<td>{{ umatKomuniItem.no_lsc }}</td>
						</tr>
						<tr>
							<td>Tanggal Komuni</td>
							<td>:</td>
							<td>{{ umatKomuniItem.tgl_komuni_human }}</td>
						</tr>						
                  <tr>
							<td>Pastor</td>
							<td>:</td>
							<td>{{ umatKomuniItem.pastor }}</td>
						</tr>
						<tr>
							<td>Keuskupan LSC</td>
							<td>:</td>
							<td>{{ umatKomuniItem.keuskupan_lsc }}</td>
						</tr>
						<tr>
							<td>Paroki LSC</td>
							<td>:</td>
							<td>{{ umatKomuniItem.paroki_lsc }}</td>
						</tr>
					</tbody>
				</table>
            
	
</template>

